import api from './api';

/**
 * Files that live behind the token.
 *
 * A `window.open` or an `<a href>` sends no Authorization header, so these used
 * to be reached by putting the token in the query string — where it lands in
 * every nginx access log, the browser history and any Referer the page leaks.
 * The bytes come through the same axios instance as everything else instead,
 * and the browser is handed an object URL.
 */
function filenameFrom(disposition, fallback) {
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition || '');
  return match ? decodeURIComponent(match[1].trim()) : fallback;
}

async function fetchFile(path) {
  const res = await api.get(path, { responseType: 'blob' });
  return {
    url: URL.createObjectURL(res.data),
    filename: filenameFrom(res.headers?.['content-disposition']),
  };
}

// revoked on a delay: revoking straight away leaves the new tab with nothing to
// render, and the download the anchor started may not have begun either.
function releaseLater(url) {
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export async function openAuthedFile(path) {
  const { url } = await fetchFile(path);
  window.open(url, '_blank', 'noopener');
  releaseLater(url);
}

export async function downloadAuthedFile(path, fallbackName) {
  const { url, filename } = await fetchFile(path);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || fallbackName || 'download';
  link.click();
  releaseLater(url);
}
